var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeerTreeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7898_56821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6841 8.15565C25.6841 12.6614 21.8716 16.3113 17.1669 16.3113C12.4622 16.3113 8.64966 12.6592 8.64966 8.15565C8.64966 3.65207 12.4622 0 17.1669 0C21.8716 0 25.6841 3.65207 25.6841 8.15565Z",
    fill: "#CDE2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1926 13.5835C22.5584 18.7203 17.8922 23.2367 11.7691 23.6689C5.64593 24.1011 0.384988 20.2886 0.0191391 15.1496C-0.34671 10.0127 4.32161 5.49629 10.4448 5.06198C16.5679 4.6298 21.8267 8.44447 22.1926 13.5813V13.5835Z",
    fill: "#CDE2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.521 16.9039C32.1689 21.8739 26.2703 24.5953 20.3483 22.9822C14.4263 21.369 10.7207 16.031 12.075 11.0589C13.4271 6.08894 19.3256 3.36753 25.2477 4.98069C31.1697 6.59385 34.8731 11.934 33.521 16.9039Z",
    fill: "#CDE2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3625 14.1954C31.4095 7.45819 22.028 7.26564 20.9197 7.21857C19.8136 7.1715 9.85226 7.45819 9.85226 7.45819L10.5733 8.42095C10.5733 8.42095 14.1333 8.13212 14.2296 11.981C14.3259 15.8299 14.2531 26.3368 14.1355 27.4044C13.8852 29.6509 14.4863 30.374 8.51937 31.095L8.50439 31.9037C8.50439 31.9037 17.3575 31.1827 25.1067 32V31.0865C25.1067 31.0865 20.9689 30.6521 20.1987 29.6915C20.1987 29.6915 19.236 28.9705 19.1889 26.9487C19.1761 26.4203 19.1718 24.5932 19.1696 22.2847C22.642 22.2826 31.3154 20.7229 31.3625 14.1954ZM25.9731 14.3879C26.5101 20.2608 20.6181 21.0502 19.1696 21.1572C19.1696 16.1166 19.1868 9.57412 19.1889 8.70978C21.2856 8.82745 25.541 9.65542 25.9731 14.3879Z",
    fill: "#2B866B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8094 22.3767L8.6499 15.6395C8.6499 15.6395 15.2416 16.7948 14.8094 22.3767Z",
    fill: "#2B866B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7898_56821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.7993,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerTreeLogo);
export default __webpack_public_path__ + "static/media/peerTreeLogo.15cdba0dffd27023ca67dae86d404aee.svg";
export { ForwardRef as ReactComponent };